import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { toCdnUrl } from "../../lib/cdn";
import { resolveImage } from "../../lib/media";
import Picture from "../Picture";
import styles from "./home-hero.module.css";

const getHeroPhotoSrc = (photo) => {
  if (!photo) return "";
  return toCdnUrl(photo);
};

const HomeHero = ({ photos: rawPhotos, onShop }) => {
  const photos = Array.isArray(rawPhotos) ? rawPhotos.filter(Boolean) : [];
  if (photos.length === 0) return null;

  const hasMultiplePhotos = photos.length > 1;

  return (
    <div className="z-10 w-full px-5">
      <div
        className={`${styles.gallery} relative mx-auto mt-4 h-[400px] max-h-[400px] max-w-full overflow-hidden rounded-2xl sm:mx-0 sm:h-[500px] sm:max-h-[500px] sm:w-full`}
      >
        <Carousel
          className="h-full"
          autoPlay={hasMultiplePhotos}
          interval={1500}
          infiniteLoop={hasMultiplePhotos}
          stopOnHover={false}
          showThumbs={false}
          showStatus={false}
          showArrows={false}
          showIndicators={false}
          animationHandler="fade"
          swipeable={false}
          onClickItem={onShop}
        >
          {photos.map((photo, index) => {
            const src = typeof photo === "string" ? photo : photo?.src;
            if (!src) return null;
            const resolved = resolveImage(src, typeof photo === "object" ? photo : null, "hero");

            if (resolved.isV2) {
              return (
                <div key={`${photo}-${index}`} className="h-full w-full overflow-hidden">
                  <Picture
                    resolved={resolved}
                    alt=""
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : undefined}
                    className="h-full w-full"
                    imgClassName="h-full w-full cursor-pointer object-cover object-center"
                  />
                </div>
              );
            }

            const legacySrc = getHeroPhotoSrc(src);

            return (
              <div key={`${src}-${index}`} className="h-full w-full overflow-hidden">
                <img
                  src={legacySrc}
                  alt=""
                  fetchpriority={index === 0 ? "high" : "auto"}
                  onError={(e) => {
                    if (e.currentTarget.src !== src) {
                      e.currentTarget.src = src;
                    }
                  }}
                  className="h-full w-full cursor-pointer object-cover object-center"
                />
              </div>
            );
          })}
        </Carousel>

        <button
          type="button"
          onClick={onShop}
          className="absolute bottom-4 left-1/2 z-30 -translate-x-1/2 rounded-full bg-[var(--theme-action-fill)] px-4 py-2 text-xs text-[var(--theme-action-text)]"
        >
          Shop All
        </button>
      </div>
    </div>
  );
};

export default HomeHero;
